var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthClientDiversityDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 188,
    viewBox: "0 0 355 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H338.667C347.503 0 354.667 7.16344 354.667 16V172C354.667 180.837 347.503 188 338.667 188H16C7.16342 188 0 180.837 0 172V16Z",
    fill: "#578BFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8932_14752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.01 172C91.98 172 57.01 137.03 57.01 94C57.01 50.97 91.98 16 135.01 16V172Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 16H21V26.4H31.4V16Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2001 36.8H41.8V47.2001H52.2001V36.8Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61 120.26V109.86L229 109.6V98.94H249.8V88.8L227.05 89.06V78.4H280.61V68L249.8 68.26V57.6L291.4 57.34V47.46H229V36.8H135.4V151.2L208.2 151.46V140.8H218.6V130.4L291.4 130.14V120.26H280.61Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4 161.6H21V172H31.4V161.6Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7999 109.6H31.3999V120H41.7999V109.6Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2001 140.8H41.8V151.2H52.2001V140.8Z",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 151.2C166.601 151.2 192.21 125.591 192.21 94C192.21 62.4094 166.601 36.8 135.01 36.8C103.419 36.8 77.8101 62.4094 77.8101 94C77.8101 125.591 103.419 151.2 135.01 151.2Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 151.2C103.42 151.2 77.8101 125.59 77.8101 94C77.8101 62.41 103.42 36.8 135.01 36.8V151.2Z",
    fill: "#578BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 140.8C160.857 140.8 181.81 119.847 181.81 94C181.81 68.153 160.857 47.2 135.01 47.2C109.163 47.2 88.21 68.153 88.21 94C88.21 119.847 109.163 140.8 135.01 140.8Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 47.2C160.88 47.2 181.81 68.13 181.81 94C181.81 119.87 160.88 140.8 135.01 140.8",
    fill: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 47.2C160.88 47.2 181.81 68.13 181.81 94C181.81 119.87 160.88 140.8 135.01 140.8",
    fill: "#578BFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 127.02C153.47 127.02 168.42 112.07 168.42 93.61C168.42 75.15 153.47 60.2 135.01 60.2C116.55 60.2 101.6 75.15 101.6 93.61C101.6 112.07 116.55 127.02 135.01 127.02Z",
    fill: "#8E76FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 64.1C151.26 64.1 164.52 77.36 164.52 93.61C164.52 109.86 151.26 123.12 135.01 123.12C118.76 123.12 105.5 109.86 105.5 93.61C105.5 77.36 118.76 64.1 135.01 64.1ZM135.01 60.2C116.55 60.2 101.6 75.15 101.6 93.61C101.6 112.07 116.55 127.02 135.01 127.02C153.47 127.02 168.42 112.07 168.42 93.61C168.42 75.15 153.47 60.2 135.01 60.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 68.52V86.33L149.57 92.96L135.01 68.52Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 68.52L120.45 92.96L135.01 86.33V68.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 104.53V116.62L149.7 95.8201L135.01 104.53Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 116.62V104.4L120.45 95.6899L135.01 116.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.01 101.8L149.57 93.09L135.01 86.46V101.8Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45 92.9601L135.01 101.8V86.3301L120.45 92.9601Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6 68H312.2V78.4H322.6V68Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8 140.8H239.4V151.2H249.8V140.8Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2 109.6H301.8V120H312.2V109.6Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 140.8H322.6V151.2H333V140.8Z",
    fill: "#45DAF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4 57.6001H208.2",
    stroke: "#0A0B0D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8 88.8H281",
    stroke: "#0A0B0D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.4 120H229",
    stroke: "#0A0B0D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4 130.4H291.4",
    stroke: "#0A0B0D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8932_14752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 156,
    fill: "white",
    transform: "translate(21 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthClientDiversityDark);
export default __webpack_public_path__ + "static/media/EthClientDiversityDark.f62024c249686fe3d8f4b3303bc1db62.svg";
export { ForwardRef as ReactComponent };